<template>
    <v-card class="mx-auto" width="559px" style="padding: 8px">
        <div style="width: 100%; margin-bottom: 10px">
            <div class="header-container">
                <h2 class="titulos header-title">Receta</h2>
                <i
                    class="mdi mdi-close-circle boton-cerrar-x"
                    @click="closeDialog"></i>
            </div>
            <hr />
        </div>
        <RecetaContenedor
            style="margin: 0 auto"
            v-if="recetaData"
            v-bind="prescriptionProps"
            ref="contentToPrint">
        </RecetaContenedor>
        <footer>
            <button
                v-if="this.practitionerIdValidation"
                :disabled="shouldDisableButton"
                @click="onPrint"
                class="button boton-principal boton-modal">
                Imprimir Receta
            </button>
        </footer>
    </v-card>
</template>

<script>
import RecetaContenedor from '@/components/global/receta-layout';
import {getPractitioner} from '@/api/practicante';
import {getRecetas} from '@/api/recetas';
import {getPatientById} from '@/api/pacientes';
import {getLocationReference} from '@/api/location';
import {getFinalNote} from '@/api/notas';
import { reactive } from 'vue';
import { printCustomPdf, isControlledMed } from '@/utils/printPdf';

export default {
    components: {
        RecetaContenedor,
    },
    props: {
        recipeId: {
            type: String,
            required: true,
        },
        patientId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            recetaData: null,
            patient: [],
            formattedDate: '',
            organizationData: '',
            itemsPatient: [],
            itemsPractitioner: [],
            practitionerLocation: [],
            practitionerId: '',
            practitionerIdValidation: false,
            itemNote: '',
        };
    },
    computed: {
        prescriptionProps() {
            const name =
                this.itemsPractitioner?.name?.length &&
                this.itemsPractitioner?.lastname?.length
                    ? `${
                          this.itemsPractitioner?.prefix
                              ? this.itemsPractitioner.prefix + ' '
                              : ''
                      }${this.itemsPractitioner.name[0]} ${
                          this.itemsPractitioner.lastname[0]
                      }${
                          this.itemsPractitioner.lastname[1]
                              ? ' ' + this.itemsPractitioner.lastname[1]
                              : ''
                      }`
                    : '';
            const qualification = this.itemsPractitioner.qualification
                ? this.itemsPractitioner.qualification
                : [];
            // const doctorUniversity = this.organizationData || '';
            const doctorZIPCode = this.itemsPractitioner.postal_code || '';
            const doctorAddress = this.practitionerLocation || [];
            const doctorInformation = this.itemsPractitioner.aditional_data
                ? this.itemsPractitioner.aditional_data[0]
                : '';
            const doctorSignature = this.itemsPractitioner.aditional_data
                ? this.itemsPractitioner.aditional_data[1]
                : '';
            const doctorPhone = this.itemsPractitioner.telecom
                ? this.itemsPractitioner.telecom[0].value
                : '';

            const patientName =
                this.itemsPatient.nombre && this.itemsPatient.primerApellido
                    ? `${this.itemsPatient.nombre} ${
                          this.itemsPatient.primerApellido
                      }${
                          this.itemsPatient.segundoApellido
                              ? ` ${this.itemsPatient.segundoApellido}`
                              : ''
                      }`
                    : '';
            const patientAge = this.itemsPatient.edad;
            const patientWeight = this.itemsPatient.peso || '';
            const finalNote = this.itemNote?.note || '';

            const prescriptions = this.recetaData.medicamentos || [];

            const date = this.recetaData[0].authoredOn;

            return reactive({
                doctorName: name,
                doctorSpecialties: qualification,
                // doctorUniversity: doctorUniversity,
                // doctorLicense: doctorLicense,
                doctorZIPCode: doctorZIPCode,
                doctorAddress: doctorAddress,
                doctorInformation: doctorInformation,
                doctorSignature: doctorSignature,
                doctorPhone: doctorPhone,
                patientName: patientName,
                patientAge: patientAge,
                patientWeight: patientWeight,
                prescriptions: prescriptions,
                finalNote: finalNote,
                date: this.currentDate(date),
                isPrint: true,
            });
        },
        shouldDisableButton() {
            return this.recetaData.some((item) => item.status === 'cancelled');
        },
    },
    mounted() {
        this.fetchRecipeData();
    },
    methods: {
        fetchPractitioner() {
            let id_med = this.practitionerId;

            if (!id_med) {
                console.error(
                    'ID del practicante no encontrado en localStorage',
                );
                return;
            }

            getPractitioner(id_med)
                .then((response) => {
                    this.itemsPractitioner = response;
                    this.organizationData =
                        this.itemsPractitioner.qualification[0].issuer.reference;
                    this.getLocations();
                })
                .catch((error) => {
                    console.error(
                        'Error al obtener los datos del médico: ',
                        error,
                    );
                });
        },
        fetchRecipeData() {
            if (!this.recipeId) {
                return;
            }
            const convertirUnidadTiempo = (unidad) => {
                switch (unidad) {
                    case 'h':
                        return 'Hora(s)';
                    case 'd':
                        return 'Día(s)';
                    case 'w':
                        return 'Semana(s)';
                    case 'm':
                        return 'Mes(es)';
                    case 'y':
                        return 'Año(s)';
                    default:
                        return unidad;
                }
            };
            getRecetas(this.recipeId).then((data) => {
                this.recetaData = data;
                this.practitionerId = data[0].practitionerId;
                this.fetchPractitioner();
                this.practitionerIdValidation =
                    localStorage.getItem('id-user') == this.practitionerId;

                this.recetaData.medicamentos = this.recetaData
                    .filter(
                        (med) =>
                            med.medicationReference?.display &&
                            med.medicationReference.display !==
                                'Sin medicamentos',
                    )
                    .map((med) => {
                        med.unitDuration = convertirUnidadTiempo(
                            med.dosageInstruction?.timing?.repeat?.boundsDuration
                                ?.unit || '',
                        );
                        med.period = convertirUnidadTiempo(
                            med.dosageInstruction?.timing?.repeat?.periodUnit || '',
                        );
                        //     itemType: this.selectedItem.art_tipo,
                        //     itemGroup: parseInt(this.selectedItem.art_grupo, 10)
                        //     productDosageForm: this.pack_product.form,
                        return {
                            recetaId: med.identifier,
                            itemDescription: med.medicationReference.display,
                            dosageInstruction: med.dosageInstruction?.text || '',
                            productBoxQuantity: med.medicationQuantity, //cantidad de cajas a surtir
                            productFrequency:
                                med.dosageInstruction?.timing?.repeat?.frequency ||
                                '',
                            productPeriodTime:
                                med.dosageInstruction?.timing?.repeat?.period || '',
                            productTypePeriodTime: med.period,
                            productDurationTime:
                                med.dosageInstruction?.timing?.repeat?.boundsDuration
                                    ?.value || '',
                            productTypeDurationTime: med.unitDuration,
                            productRoute: med.dosageInstruction?.route?.text || '',
                            productNote: med.note,
                            itemBrand: med.marca,
                            category: med.category || 'normal',
                        };
                    });
                this.recetaData.medicamentos.sort((a, b) => {
                    const aControlled = isControlledMed(a) ? 1 : 0;
                    const bControlled = isControlledMed(b) ? 1 : 0;
                    return bControlled - aControlled;
                });
                const date = new Date(this.recetaData[0].authoredOn);
                this.formDate(date);
            });
            // .catch((error) => {
            //     console.error('Error fetching recipe data:', error);
            // });
            getPatientById(this.patientId)
                .then((patient) => {
                    this.itemsPatient = patient;
                })
                .catch((error) => {
                    console.log(error);
                });
            getFinalNote(this.recipeId)
                .then((finalNote) => {
                    this.itemNote = finalNote;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLocations() {
            getLocationReference(this.itemsPractitioner.location)
                .then((response) => {
                    this.practitionerLocation = response.location;
                })
                .catch((error) => {
                    console.error('Error al obtener las sucursales: ', error);
                });
        },
        formDate(ISOdate) {
            const date = new Date(ISOdate);
            return date.toLocaleDateString('es-ES', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        },
        currentDate(ISOdate) {
            const date = new Date(ISOdate);
            const day = String(date.getDate()).padStart(2, '0'); // Asegura 2 dígitos
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses van de 0 a 11
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        onPrint() {
            printCustomPdf(
                this.recipeId,
                this.recetaData,
                this.prescriptionProps,
            );
        },
        closeDialog() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
footer {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
}

/* q */
.data-value {
    flex: 1;
    border-bottom: 1px solid #000;
}

.data-label {
    color: var(--color-principal);
    margin-right: 10px;
}

.footer {
    height: 10%;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: end;
}

.boton-modal {
    width: 150px;
    display: flex;
    justify-content: center;
}

.estilo-texto {
    color: var(--color-secundario);
    font-weight: bold;
}

.boton-cerrar {
    background-color: #d66363;
    color: white;
}
.header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.header-title {
    flex: 1;
    text-align: center;
    margin: 0;
}
.boton-cerrar-x {
    color: rgb(195, 14, 14);
    cursor: pointer;
    font-size: 25px;
    padding-bottom: 10px;
}
.boton-cerrar-x:hover {
    color: rgb(245, 115, 115);
}
</style>
